import React, { useState } from 'react';
import api from '../services/api';
import toast from 'react-hot-toast';

function ProfilePage() {
  const currentUser = JSON.parse(localStorage.getItem('user'));

  const [formDetails, setFormDetails] = useState({
    first_name: currentUser?.first_name || '',
    last_name: currentUser?.last_name || ''
  });

  const [passwordState, setPasswordState] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });

  const handleDetailsChange = (e) => {
    setFormDetails({ ...formDetails, [e.target.name]: e.target.value });
  };

  const handleDetailsSubmit = async (e) => {
    e.preventDefault();
    const loadingToast = toast.loading('Salvando alterações...');
    try {
      const payload = {
          name: `${formDetails.first_name} ${formDetails.last_name}`.trim(),
          first_name: formDetails.first_name,
          last_name: formDetails.last_name
      };
      const response = await api.put('/users/me/details', payload);

      localStorage.setItem('user', JSON.stringify(response.data.user));

      toast.dismiss(loadingToast);
      toast.success(response.data.message);

      setTimeout(() => window.location.reload(), 1500);

    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error('Erro ao atualizar dados: ' + (error.response?.data?.error || 'Tente novamente.'));
    }
  };

  const handlePasswordChange = (e) => {
    setPasswordState({ ...passwordState, [e.target.name]: e.target.value });
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (passwordState.new_password !== passwordState.confirm_password) {
      toast.error("A nova senha e a confirmação não correspondem.");
      return;
    }
    const loadingToast = toast.loading('Alterando senha...');
    try {
      const response = await api.put('/users/me/password', {
        current_password: passwordState.current_password,
        new_password: passwordState.new_password
      });
      toast.dismiss(loadingToast);
      toast.success(response.data.message);
      setPasswordState({ current_password: '', new_password: '', confirm_password: '' });
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error('Erro ao alterar senha: ' + (error.response?.data?.error || 'Tente novamente.'));
    }
  };

  return (
    <>
      <div className="mb-8">
        <h2 className="text-3xl font-bold font-manrope text-slate-900 tracking-tight mb-2">Meu Perfil</h2>
        <p className="text-sm font-medium text-slate-500">Gerencie suas informações pessoais e de segurança.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="bg-white rounded-xl border border-slate-200 p-8 shadow-sm">
          <div className="flex items-center space-x-3 mb-6">
             <div className="w-10 h-10 rounded-lg bg-indigo-50 text-primary flex items-center justify-center">
                <span className="material-symbols-outlined">person</span>
             </div>
             <h3 className="text-xl font-bold font-manrope text-slate-900">Detalhes Pessoais</h3>
          </div>
          <form className="space-y-5" onSubmit={handleDetailsSubmit}>
            <div>
              <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Email (não pode ser alterado)</label>
              <input type="email" value={currentUser?.email || ''} disabled className="w-full bg-slate-100 border border-slate-200 rounded-lg px-4 py-3 text-sm font-medium text-slate-500 cursor-not-allowed outline-none" />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label htmlFor="first_name" className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Nome</label>
                <input id="first_name" name="first_name" type="text" value={formDetails.first_name} onChange={handleDetailsChange} required className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm font-medium text-slate-800 outline-none focus:ring-2 focus:ring-primary" />
              </div>
              <div>
                <label htmlFor="last_name" className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Sobrenome</label>
                <input id="last_name" name="last_name" type="text" value={formDetails.last_name} onChange={handleDetailsChange} className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm font-medium text-slate-800 outline-none focus:ring-2 focus:ring-primary" />
              </div>
            </div>
            <button type="submit" className="w-full bg-primary text-white font-bold py-3.5 px-4 rounded-xl shadow-md hover:bg-indigo-700 transition-colors mt-6">Salvar Alterações</button>
          </form>
        </div>

        <div className="bg-white rounded-xl border border-slate-200 p-8 shadow-sm">
          <div className="flex items-center space-x-3 mb-6">
             <div className="w-10 h-10 rounded-lg bg-orange-50 text-orange-600 flex items-center justify-center">
                <span className="material-symbols-outlined">lock</span>
             </div>
             <h3 className="text-xl font-bold font-manrope text-slate-900">Alterar Senha</h3>
          </div>
          <form className="space-y-5" onSubmit={handlePasswordSubmit}>
             <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Senha Atual</label>
                <input name="current_password" type="password" value={passwordState.current_password} onChange={handlePasswordChange} placeholder="Sua senha atual" required className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm font-medium text-slate-800 outline-none focus:ring-2 focus:ring-primary" />
             </div>
             <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Nova Senha</label>
                <input name="new_password" type="password" value={passwordState.new_password} onChange={handlePasswordChange} placeholder="No mínimo 6 caracteres" required className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm font-medium text-slate-800 outline-none focus:ring-2 focus:ring-primary" />
             </div>
             <div>
                <label className="block text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-2">Confirme a Nova Senha</label>
                <input name="confirm_password" type="password" value={passwordState.confirm_password} onChange={handlePasswordChange} placeholder="Repita a nova senha" required className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm font-medium text-slate-800 outline-none focus:ring-2 focus:ring-primary" />
             </div>
            <button type="submit" className="w-full bg-slate-900 text-white font-bold py-3.5 px-4 rounded-xl shadow-md hover:bg-slate-800 transition-colors mt-6">Atualizar Senha</button>
          </form>
        </div>
      </div>
    </>
  );
}

export default ProfilePage;